export const PENDENTE = {
  value: 'PENDENTE',
  label: 'Pendente',
  numberValue: 0,
};
export const APROVADO = {
  value: 'APROVADO',
  label: 'Aprovado',
  numberValue: 1,
};
export const RECUSADO = {
  value: 'RECUSADO',
  label: 'Recusado',
  numberValue: 2,
};
export const REMOVIDO = {
  value: 'REMOVIDO',
  label: 'Removido',
  numberValue: 3,
};

export const PREREGISTRATION_STATUS_ENUM = [
  PENDENTE,
  APROVADO,
  RECUSADO,
  REMOVIDO,
];
